import React from "react";
import LBox from "@components/LBox";
import { _spacing, _slideWidth, _slideHeight, Indicators } from "./parallax";
import Animated from "react-native-reanimated";
import AccessCardContent from "@components/Exclusives/FeedAccess/AccessCarousel/AccessCardContent";
import { useAccessCarouselData } from "@components/Exclusives/FeedAccess/AccessCarousel/useAccessCarouselData";
import { useActiveSong } from "@utils/player";

const SHIFT_AMOUNT = _spacing / 4;

const AccessCarousel = ({ artistId }: { artistId: string }) => {
  const { data, onScroll, scrollX } = useAccessCarouselData(artistId);

  if (!artistId) return null;
  return (
    <LBox
      width={_slideWidth + SHIFT_AMOUNT}
      height={_slideHeight}
      borderRadius="m-l"
      overflow="hidden"
    >
      <Animated.FlatList
        data={data}
        keyExtractor={(_, index) => String(index)}
        contentContainerStyle={{
          gap: _spacing,
          justifyContent: "center",
        }}
        style={
          {
            scrollSnapType: "x mandatory",
            scrollBehavior: "smooth",
            WebkitOverflowScrolling: "touch",
          } as any
        }
        renderItem={({ item, index }) => {
          if (!item) return null;
          return (
            <LBox
              style={
                {
                  scrollSnapAlign: "center",
                  scrollSnapStop: "always",
                } as any
              }
            >
              <AccessCardContent index={index} data={item} scrollX={scrollX} />
            </LBox>
          );
        }}
        showsHorizontalScrollIndicator={false}
        horizontal
        onScroll={onScroll}
        scrollEventThrottle={1000 / 60}
      />
      {data.length > 1 && (
        <LBox
          position="absolute"
          bottom={8}
          left={0}
          right={SHIFT_AMOUNT}
          alignItems="center"
        >
          <Indicators numberOfCards={data.length} scrollX={scrollX} />
        </LBox>
      )}
    </LBox>
  );
};

const AccessCarouselWrapper = () => {
  const activeSong = useActiveSong();
  const artistId = activeSong?.artists.at(0)?.id ?? null;
  if (!artistId) return null;
  return <AccessCarousel artistId={artistId} />;
};
export default AccessCarouselWrapper;
